import { type AxiosError } from 'axios';

/**
 * Pull a human-readable message out of an API error response, falling back to a
 * default. NestJS exceptions carry `message` as a string (e.g. ConflictException)
 * or a string[] (validation errors), so both shapes are handled.
 */
export const getApiErrorMessage = (error: unknown, fallback: string): string => {
  const message = (error as AxiosError<{ message?: string | string[] }>)
    ?.response?.data?.message;

  const candidate = Array.isArray(message)
    ? message.find((entry) => entry?.trim())
    : message;

  // Blank or whitespace-only messages would surface as an empty toast.
  return candidate?.trim() ? candidate : fallback;
};
